(function () {
  'use strict';
  if (window.__emaFoodOfferReady) return;
  var dialog = document.getElementById('ema-food-dialog');
  var configNode = document.getElementById('ema-food-config');
  if (!dialog || !configNode || typeof dialog.showModal !== 'function') return;
  window.__emaFoodOfferReady = true;
  var cfg = JSON.parse(configNode.textContent);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var request = window.fetch.bind(window);
  var select = dialog.querySelector('select');
  var addButton = dialog.querySelector('[data-food-add]');
  var errorNode = dialog.querySelector('[data-food-error]');
  var offers = [], pending = false, busy = false, addedVariant = null, opener = null;
  var sessionKey = 'ema_fish_food_shown';
  var timeKey = 'ema_fish_food_ts';
  var shownInPage = false;
  var foodHandles = ['fauna-marin-soft-multi-mix', 'fauna-marin-soft-protein-super-food-m', 'fauna-marin-soft-protect', 'fauna-marin-100-natural-green-seaweed-2'];
  function money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', { style: 'currency', currency: cfg.currency || 'NZD' }).format(cents / 100); }
  function afterDiscount(cents) { return cents - Math.round(cents * cfg.percentage / 100); }
  function isFish(item) { return /^(marine fish|fish|saltwater fish)$/i.test(String(item.product_type || '').trim()); }
  function hasFood(cart) { return cart.items.some(function (item) { return foodHandles.indexOf(item.handle) !== -1; }); }
  function conflictingDiscount(cart) {
    return (cart.discount_codes || []).some(function (d) { return d.applicable !== false && String(d.code).toUpperCase() !== cfg.code; }) ||
      (cart.cart_level_discount_applications || []).some(function (d) { return String(d.title).toUpperCase() !== cfg.code; }) ||
      cart.items.some(function (item) { return (item.line_level_discount_allocations || []).some(function (d) { return String((d.discount_application || {}).title).toUpperCase() !== cfg.code; }); });
  }
  function seen() {
    if (shownInPage) return true;
    try { return !!sessionStorage.getItem(sessionKey) || Date.now() - Number(localStorage.getItem(timeKey) || 0) < 30 * 86400000; } catch (e) { return false; }
  }
  function markShown() { shownInPage = true; try { sessionStorage.setItem(sessionKey, '1'); localStorage.setItem(timeKey, String(Date.now())); } catch (e) {} }
  async function json(path, body) {
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (body) { options.method = 'POST'; options.headers = { 'Content-Type': 'application/json' }; options.body = JSON.stringify(body); }
    var response = await request(root + path, options);
    if (!response.ok) throw new Error('request_failed');
    return response.json();
  }
  async function liveOffers() {
    var response = await request(root + '?section_id=ema-fish-food-data&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('offers_failed');
    var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    var node = doc.querySelector('[data-ema-food-data]');
    var data = node ? JSON.parse(node.textContent) : [];
    return data.filter(function (p) { return p.id && p.price > 0 && foodHandles.indexOf(p.handle) !== -1; });
  }
  function displayOffer() {
    var offer = offers.find(function (p) { return String(p.id) === select.value; });
    if (!offer) return;
    dialog.querySelector('[data-food-image]').src = offer.image;
    dialog.querySelector('[data-food-image]').alt = offer.title;
    dialog.querySelector('[data-food-was]').textContent = money(offer.price);
    dialog.querySelector('[data-food-price]').textContent = money(afterDiscount(offer.price));
    dialog.querySelector('[data-food-saving]').textContent = cfg.strings.save.replace('[amount]', money(offer.price - afterDiscount(offer.price)));
    errorNode.hidden = true;
  }
  function fillOffers(data, selected) {
    offers = data; select.replaceChildren();
    offers.forEach(function (p) { var option = document.createElement('option'); option.value = String(p.id); option.textContent = p.title.replace(/^Fauna Marin\s*/i, '') + (p.variant_title && p.variant_title !== 'Default Title' ? ' · ' + p.variant_title : ''); select.appendChild(option); });
    if (offers.some(function (p) { return String(p.id) === String(selected); })) select.value = String(selected);
    displayOffer();
  }
  function message(text) { errorNode.textContent = text; errorNode.hidden = false; }
  function close() { if (busy) return; dialog.close(); if (opener && opener.isConnected) opener.focus(); }
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    if (!document.querySelector('cart-drawer')) window.location.assign(root + 'cart');
  }
  async function maybePrompt(items) {
    if (!items.some(isFish) || seen() || pending || dialog.open) return;
    pending = true;
    try {
      var cart = await json('cart.js');
      if (!cart.items.some(isFish) || hasFood(cart) || conflictingDiscount(cart)) return;
      var data = await liveOffers();
      if (!data.length || seen()) return;
      await new Promise(function (resolve) { setTimeout(resolve, 1000); });
      if (document.querySelector('.ema-glue-wrapper--visible')) return;
      fillOffers(data); opener = document.activeElement;
      dialog.showModal(); markShown();
    } catch (e) {} finally { pending = false; }
  }
  function observe(data) { var items = Array.isArray(data.items) ? data.items : data.id ? [data] : []; maybePrompt(items); }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url || String(input);
    var method = (init && init.method) || (input && input.method) || 'GET';
    var atc = false;
    try { var parsed = new URL(url, window.location.href); atc = parsed.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname) && method.toUpperCase() === 'POST'; } catch (e) {}
    return request(input, init).then(function (response) {
      if (atc && response.ok) response.clone().json().then(observe).catch(function () {});
      return response;
    });
  };
  var xhrOpen = XMLHttpRequest.prototype.open, xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._emaFoodAtc = false;
    try { var parsed = new URL(url, location.href); this._emaFoodAtc = parsed.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname) && String(method).toUpperCase() === 'POST'; } catch (e) {}
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._emaFoodAtc) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) { try { observe(this.responseType === 'json' ? this.response : JSON.parse(this.responseText)); } catch (e) {} } }, { once: true });
    return xhrSend.apply(this, arguments);
  };
  document.addEventListener('on:cart:add', function (event) { var detail = event.detail || {}; if (detail.cart) maybePrompt(detail.cart.items.filter(function (p) { return p.variant_id === detail.variantId; })); });
  select.addEventListener('change', displayOffer);
  dialog.querySelectorAll('[data-food-close]').forEach(function (button) { button.addEventListener('click', close); });
  dialog.addEventListener('cancel', function (event) { if (busy) event.preventDefault(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
  addButton.addEventListener('click', async function () {
    if (busy) return;
    busy = true; addButton.disabled = true; select.disabled = true; addButton.textContent = cfg.strings.adding; errorNode.hidden = true;
    try {
      var offer = offers.find(function (p) { return String(p.id) === select.value; });
      var cart = await json('cart.js');
      if (!addedVariant) {
        if (!cart.items.some(isFish) || hasFood(cart) || conflictingDiscount(cart)) { busy = false; close(); return; }
        var fresh = await liveOffers();
        var current = fresh.find(function (p) { return p.id === offer.id; });
        if (!current) { if (fresh.length) fillOffers(fresh); message(cfg.strings.unavailable); if (!fresh.length) addButton.dataset.unavailable = 'true'; return; }
        if (current.price !== offer.price) { fillOffers(fresh, current.id); message(cfg.strings.changed); return; }
        var result = await json('cart/add.js', { items: [{ id: current.id, quantity: 1 }] });
        if (!result.items || !result.items.some(function (p) { return p.variant_id === current.id || p.id === current.id; })) throw new Error('add_failed');
        addedVariant = current.id;
      }
      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      if (!codes.some(function (code) { return String(code).toUpperCase() === cfg.code; })) codes.push(cfg.code);
      var updated = await json('cart/update.js', { discount: codes.join(',') });
      var line = updated.items.find(function (p) { return p.variant_id === addedVariant || p.id === addedVariant; });
      var applied = line && (line.line_level_discount_allocations || []).some(function (d) { return String((d.discount_application || {}).title).toUpperCase() === cfg.code && d.amount > 0; });
      if (!applied) throw new Error('discount_failed');
      busy = false; close(); refreshCart();
    } catch (e) {
      message(addedVariant ? cfg.strings.discount_error : cfg.strings.error);
      if (addedVariant) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    } finally {
      busy = false; addButton.disabled = addButton.dataset.unavailable === 'true'; select.disabled = !!addedVariant; addButton.textContent = cfg.strings.add;
    }
  });
})();
